const Folder = ({ children, onClick, bgColor="bg-rs-azul/75" , ...res }) => {

    return (
        <button
            className="w-full flex flex-col"
            onClick={onClick}
            {...res}
        >
            <div
                className={`w-1/2 h-4 ${bgColor}`}
                style={{
                    clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 100%, 0% 100%)',
                    borderTopLeftRadius: '0.75rem',
                }}
            />
            <div className={`w-full h-[33vh] ${bgColor} rounded-xl rounded-tl-none shadow-lg p-4`}>
                {children}
            </div>
        </button>
    );
};

export default Folder;